import React from 'react';
import { Button, Checkbox, Form, Input, Modal } from 'antd';
import { getData } from '../utils';
import { addOrRemoveFromWishList, fetchAllWishLists } from '../reducer';
import { connect } from 'react-redux';

class CreateWishListModal extends React.Component {
    constructor(props) {
        super(props);
        this.createFormRef = React.createRef();
        this.state = { open: this.props.open };
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.open !== this.state.open) this.setState({ open: this.props.open });
    }

    createWishList = (values) => {
        let wishList = {};
        wishList.name = values.name;
        wishList.description = values.description;
        wishList.publicWishList = values.publicWishList;
        wishList.quantityEnabled = values.quantityEnabled;
        getData('CreateWishList', wishList)
            .then((r) => {
                this.props.dispatch(
                    addOrRemoveFromWishList(null, this.props.productIDToAdd, null, r.wishList.id)
                );
            })
            .then(() => {
                this.props.dispatch(fetchAllWishLists());
            })
            .then(this.props.toggleOpen);
    };

    render() {
        return (
            <Modal
                open={this.state.open}
                title="Stofna óskalista"
                onCancel={this.props.toggleOpen}
                footer={[
                    <Button
                        className={'origo-button white'}
                        key="back"
                        onClick={this.props.toggleOpen}
                    >
                        Loka
                    </Button>,
                    <Button
                        onClick={() => this.createFormRef.current.submit()}
                        className={'origo-button'}
                    >
                        Stofna
                    </Button>,
                ]}
            >
                <Form ref={this.createFormRef} onFinish={this.createWishList}>
                    <Form.Item
                        name="name"
                        hasFeedback
                        rules={[
                            {
                                required: true,
                                message: 'Sláðu inn nafn á listanum',
                            },
                            {
                                type: 'string',
                                max: 128,
                                message: 'Nafn lista getur ekki verið lengra en 128 stafir',
                            },
                        ]}
                    >
                        <Input placeholder={'Nafn lista'} />
                    </Form.Item>
                    <Form.Item
                        name="description"
                        hasFeedback
                        rules={[
                            {
                                type: 'string',
                                max: 255,
                                message: 'Lýsing lista getur ekki verið lengri en 255 stafir',
                            },
                        ]}
                    >
                        <Input.TextArea placeholder={'Lýsing lista'} rows={3} />
                    </Form.Item>
                    <Form.Item name="publicWishList" valuePropName="checked">
                        <Checkbox value={true}>Hægt að deila lista</Checkbox>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

const mapStateToProps = () => {
    return {};
};

export default connect(mapStateToProps, null)(CreateWishListModal);
